import React from 'react';
import * as Routes from '@/modules/routes';
import Icon, { type ValidIcon } from '@/components/ui/Icon';
import { toValidIcon } from '@/components/admin/SlideShow/Utils/icons';
import { slideGroupInitialValues } from '../utils';
import useLessonOverviewContext from '../../useLessonOverviewContext';
import FullWidthCard from './FullWidthCard';

const DEFAULT_ICONS_BY_LOCATION: Record<string, ValidIcon> = {
  introduce_the_lesson: 'Observe',
  put_it_all_together: 'PencilBubble',
};

const FALLBACK_ICON: ValidIcon = 'HandsOn';

interface SlideGroupCardProps {
  slideGroup: any;
}

const SlideGroupCard = ({ slideGroup }: SlideGroupCardProps) => {
  const lessonId = useLessonOverviewContext(state => state.lessonId);
  const programId = useLessonOverviewContext(state => state.programId);
  const programColor = useLessonOverviewContext(state => state.programColor);
  const icon = toValidIcon(slideGroup.icon)
    || DEFAULT_ICONS_BY_LOCATION[slideGroup.displayLocationInLessonOverview]
    || FALLBACK_ICON;

  const presentPath = Routes.present_mode_shared_slide_show_path(slideGroup.slideShowId ?? slideGroup.slide_show_id, {
    from: 'lesson',
    parent_id: lessonId,
    parent_type: 'Lesson',
    program_id: programId,
    starting_slide: slideGroup.firstSlideId,
  });

  const initialValues = slideGroupInitialValues(slideGroup);

  return (
    <FullWidthCard
      borderLeft
      openInNewWindow
      icon={<Icon color="#3c3c3c" icon={icon} size={42} />}
      initialValues={initialValues}
      isAssigned={slideGroup.isAssigned}
      pacing={slideGroup.pacing}
      page={slideGroup.page}
      presentPath={presentPath}
      programColor={programColor}
      title={slideGroup.title}
    />
  );
};

export default SlideGroupCard;
